import {observer} from "mobx-react"
import React, {Component, Fragment} from "react"
import {Button, Icon, Input, Segment} from "semantic-ui-react"
import shop from "shop/shop"
import cmsStore from "stores/cmsStore"
import _ from "lodash"
import {Link} from "react-router-dom"
import Price from "components/Price/Price"
import ButtonLove from "components/Button/ButtonLove"
import { Label, Modal } from "semantic-ui-react"
import OrderModel   from "shop/OrderModel";
import ImageWithFallback from "components/ImageWithFallback"
import ProductImages from "components/Product/ProductImages"
import ProductFullscreen from "components/Product/ProductFullscreen"
import Responsive                                                from "react-responsive"
import Collapsible                                                                    from 'react-collapsible';

let orders = []
let ordersWithOpenPositions = []
let openPositions = []
let current = 0

@observer
export default class ProductListItem extends Component {

	state = {
		session: shop.session || {}, locations: [], showAddressBook: false, noMoreOrders: false, orderOpen: [], maxOrders: 5, maxOpenOrders: 5, bausteinValue: "", bausteinSeason: "", fullscreenElement: null,
	  }

	  loadSession = ( session ) => {
		this.setState( { noMoreOrders: false } )
	  }
	  componentDidMount() {
		orders = []
		ordersWithOpenPositions = []
		openPositions = []
		current = 0
		shop.events.authentified.add( this.loadSession )
		this.handleGetExtras()
		// this.loadSession()
	  }
	  handleGetExtras = () => {
        console.log("EXTRAS", shop.cart.data)
        if(shop.cart && shop.cart.data && shop.cart.data.extras && shop.cart.data.extras.bausteinValue){
            this.setState({bausteinValue: shop.cart.data.extras.bausteinValue})
			this.setState({bausteinSeason: shop.cart.data.extras.bausteinSeason})
        }
      }
	 showFullscreen = ( element ) => {
		console.log("PRODUCTIMAGE showFullscreen", element)
		this.setState( {
			fullscreenElement: element
		} )
	}
	setPrimaryImage = ( primaryImage ) => {
		this.setState( {primaryImage} )
	}
	
	render() {
		let {product, index, categoryId = "", to = "/", search = "", history, place, additionalArticle} = this.props
		let { bausteinValue, bausteinSeason, fullscreenElement, primaryImage } = this.state
		let isAdditionalArticle = additionalArticle || (product.extras && product.extras.additionalArticle === true)
		console.log("this.props",product, bausteinValue, bausteinSeason, history)
		if ( !product ) return <div>NO PRODUCT</div>
		let configByCategory = cmsStore.config.orthoFieldConfigByCategory[String( product.category && product.category.map_id )]

		let isDefaultConfig = false
		if ( !configByCategory ) {
			isDefaultConfig = true
			configByCategory = cmsStore.config.orthoFieldConfigByCategory["DEFAULT"]
		}
		const columnChunks = _.chunk( configByCategory.columns, 1 )
		const inCart = shop.cart.productsById.get( product.map_id ) || product

		if(product.map_id == bausteinValue){
			console.log("found bausteinValue: ", product.map_id, bausteinValue, bausteinSeason, product)
		}
		
		let productImage = false
		let img_srcs = product.img_srcs
		if ( product.img_src ) {
			productImage = product.img_src_large
		}

		if ( primaryImage ) productImage = primaryImage

		const formatPrice = (price) => {
			if (!price) return "0,00"
			return (price).toFixed(2).toString().replace(".", ",").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
		}

		return ( 
			<React.Fragment>
				<ProductFullscreen
					change={this.showFullscreen}
					images={img_srcs}
					image={fullscreenElement} />

				<Responsive minWidth={992}>
					<div
					attached={"bottom"}
					className={`product db mt2 mb2 w-100  relative ${isAdditionalArticle ? "ProductListItem-additional" : (product.map_id == bausteinValue+bausteinSeason ? "ProductListItem-highlight" : "ProductListItem")}`}>
					<div className="ProductListItem-row ProductListItem-row-header">
						<div className="ProductListItem-col ProductListItem-col-image">&nbsp;</div>
						<div className="ProductListItem-col ProductListItem-col-baustein">{additionalArticle ? "Zusatzsortiment" : "Baustein"}</div>
						<div className="ProductListItem-col ProductListItem-col-beschreibung">Beschreibung</div>
						<div className="ProductListItem-col ProductListItem-col-uvp">UVP</div>
						<div className="ProductListItem-col ProductListItem-col-fap">FAP</div>
						<div className="ProductListItem-col ProductListItem-col-action">{isAdditionalArticle ? "Menge" : "\u00A0"}</div>
					</div>
					<div className="ProductListItem-row">
						<div className="ProductListItem-col ProductListItem-col-image">{<ProductImages
															key={product.map_id}
															product={product}
															images={img_srcs}
															image={productImage}
															onClick={this.showFullscreen}
															onClickSecondary={this.setPrimaryImage} />} </div>
						<div className="ProductListItem-col ProductListItem-col-baustein">{<div className={"f5  w-100"} key={product.map_id + "desc"}>{product.desc.short_des}</div>}</div>
						<div className="ProductListItem-col ProductListItem-col-beschreibung">{<div className={"f5  w-100"} key={product.map_id + "desc"}>{product.desc.des}</div>}</div>
						<div className="ProductListItem-col ProductListItem-col-uvp">{<div className={"f5  w-100"} key={product.map_id + "desc"}>{product.extras && product.extras.uvp && product.extras.uvp.value.value}</div>}</div>
						<div className="ProductListItem-col ProductListItem-col-fap">{<div className={"f5  w-100"} key={product.map_id + "desc"}>€ {formatPrice(product.price)}</div>}</div>
						{place != "return" && <div className="ProductListItem-col ProductListItem-col-action pr3"><ProductQuantitySimple primaryProduct={product.map_id == bausteinValue+bausteinSeason ? true : false}  place={place} product={product} inCart={inCart} history={history} additionalArticle={additionalArticle} /></div>}
						{place == "return" && isAdditionalArticle && <div className="ProductListItem-col ProductListItem-col-action pr3">{product.count}</div>}
					</div>
					<div className="bausteinInhalt_div">
						<Collapsible tabIndex={0} open={false} trigger={translate( additionalArticle ? "Zusatzsortimentinhalt" : "Bausteininhalt" )}>
						<div className="f6 gray">Hier finden Sie eine Auflistung der Displays, die in diesem {additionalArticle ? "Zusatzsortiment" : "Baustein"} enthalten sind.</div>
						<div className="bausteinInhalt-table">
							<div className="bausteinInhalt-row">
								<div className="bausteinInhalt-col bausteinInhalt-col-display"><strong>{translate("Display")}</strong></div>
								<div className="bausteinInhalt-col bausteinInhalt-col-bezeichnung"><strong>{translate("Bezeichnung")}</strong></div>
								<div className="bausteinInhalt-col bausteinInhalt-col-menge"><strong>{translate("Menge")}</strong></div>
							</div>
						{product.extras && product.extras.inhalt && product.extras.inhalt.value && JSON.parse(product.extras.inhalt.value.value).map((item, idx) => (
						<div key={idx} className="bausteinInhalt-row">
							<div className="bausteinInhalt-col bausteinInhalt-col-display">{item.display}</div>
							<div className="bausteinInhalt-col bausteinInhalt-col-bezeichnung tl">{item.bezeichnung}</div>
							<div className="bausteinInhalt-col bausteinInhalt-col-menge">{item.menge} {translate(additionalArticle ? "Display" : "Display")}</div>
						</div>
					))}
							</div>

							</Collapsible>
						</div>
					</div>
					</Responsive>
					
				<Responsive maxWidth={991}>
					<div className={`pa3 mb3 ${product.map_id == bausteinValue+bausteinSeason ? "bausteinSegment-highlight" : (isAdditionalArticle ? "bausteinSegment-additional" : "bausteinSegment")}`}>
					<div className="ProductListItem-mobile-table w-100">
						<div className="ProductListItem-mobile-row">
							<div className="ProductListItem-mobile-col-label">
								&nbsp;
							</div>
							<div className="ProductListItem-mobile-col-value" style={{maxWidth: "70px", maxHeight: "70px", minWidth: "70px", minHeight: "70px"}}>
								{<ProductImages
															key={product.map_id}
															product={product}
															images={img_srcs}
															image={productImage}
															onClick={this.showFullscreen}
															onClickSecondary={this.setPrimaryImage} />}
							</div>
						</div>
						<div className="ProductListItem-mobile-row">
							<div className="ProductListItem-mobile-col-label ProductRowDefReturnMobileLeftNonLast">{additionalArticle ? "Zusatzsortiment:" : "Baustein:"}</div>
							<div className="ProductListItem-mobile-col-value ProductRowDefReturnMobileRightNonLast tr f7">
								{product.desc.short_des}
							</div>
						</div>
						<div className="ProductListItem-mobile-row">
							<div className="ProductListItem-mobile-col-label ProductRowDefReturnMobileLeftNonLast">Beschreibung:</div>
							<div className="ProductListItem-mobile-col-value ProductRowDefReturnMobileRightNonLast tr">
								{product.desc.des || "-"}
							</div>
						</div>
						<div className="ProductListItem-mobile-row">
							<div className="ProductListItem-mobile-col-label ProductRowDefReturnMobileLeftNonLast">UVP:</div>
							<div className="ProductListItem-mobile-col-value ProductRowDefReturnMobileRightNonLast tr">
								{product.extras && product.extras.uvp && product.extras.uvp.value.value}
							</div>
						</div>
						<div className="ProductListItem-mobile-row">
							<div className="ProductListItem-mobile-col-label ProductRowDefReturnMobileLeftNonLast">Preis:</div>
							<div className="ProductListItem-mobile-col-value ProductRowDefReturnMobileRightNonLast tr">
								€ {formatPrice(product.price)}
							</div>
						</div>
						<div className="ProductListItem-mobile-row">
							<div className="ProductListItem-mobile-col-full pt4">
								{place != "return" && <ProductQuantitySimple primaryProduct={product.map_id == bausteinValue+bausteinSeason ? true : false} place={place} product={product} inCart={inCart} history={history} additionalArticle={additionalArticle} />}
								{place == "return" && isAdditionalArticle && <div>{product.count}</div>}
							</div>
						</div>
					</div>
					<div className="bausteinInhalt_div_mobile">
						<Collapsible tabIndex={0} open={false} trigger={translate( additionalArticle ? "Zusatzsortimentinhalt" : "Bausteininhalt" )}>
						<div className="f6 gray">Hier finden Sie eine Auflistung der Displays, die in diesem {additionalArticle ? "Zusatzsortiment" : "Baustein"} enthalten sind.</div>

						{product.extras && product.extras.inhalt && product.extras.inhalt.value && JSON.parse(product.extras.inhalt.value.value).map((item, idx) => (
							<Fragment key={idx}>
								<div className=" bb b--black-30 pt2 pb2">
									<div className="bausteinInhalt_div_mobile"><strong>{translate("Display:")}&nbsp;</strong> {item.display}</div>
									<div className="bausteinInhalt_div_mobile"><strong>{translate("Bezeichnung:")}&nbsp;</strong><p className="tr"> {item.bezeichnung}</p></div>
									<div className="bausteinInhalt_div_mobile"><strong>{translate("Menge:")}&nbsp;</strong> {item.menge} {translate("Display")}</div>
								</div>
							</Fragment>))}
						</Collapsible>
					</div>
					</div>
				</Responsive>
			</React.Fragment>
		)
	}
}

function ProductQuantitySimple( {primaryProduct, place, product, inCart = {}, history, additionalArticle} ) {
  const minBuy = Number(product.pinfos && product.pinfos.minbuy) || 1
  const [count, setCount] = React.useState((inCart && inCart.count) || minBuy)
  const [isDirty, setDirty] = React.useState(false)
  const [isLoading, setLoading] = React.useState(false)
  const [modalOpen, setModalOpen] = React.useState(false)

  const same = count === inCart.count

  React.useEffect(() => {
    if (isDirty) return
    setCount(inCart.count || minBuy)
  }, [product, inCart])
	return <div className={"ProductQuantitySimple flex flex-row items-center"}>
				<Modal
					closeIcon={<Icon name="close" />}
					open={modalOpen}
					onClose={() => setModalOpen(false)}
					size="tiny"
				>
					<Modal.Header>{translate( "Sind Sie sicher, dass Sie einen von unserem Vorschlag abweichenden Baustein bestellen möchten?" )}</Modal.Header>
					<Modal.Content>
					<div className="f4 fw5 pb3 pt2 flex flex-row justify-between">
						                  <Button
                    style={{ borderRadius: "25px", height: "45px" }}
                    primary
                    onClick={async () => {
                      	// Falls User im Modal bestätigt → Produkt trotzdem hinzufügen
						let n = 1
						setLoading(true)

						product.count = n
						if(additionalArticle){
							//TODO
						}
						else{
							const productsToRemove = shop.cart.products.filter(p => !(p.extras && p.extras.additionalArticle === true))
							console.log("productsToRemove", productsToRemove)
							for (const p of productsToRemove) {
								await shop.cart.remove(p)
							}
						}
						await shop.cart.setExtra("lieferzeitraum", product.extras && product.extras.lieferzeitraum && product.extras.lieferzeitraum.value ? product.extras.lieferzeitraum.value.value : "")

						await shop.cart.add( product )
						await shop.cart.setExtra("bausteinValue", product.map_id.substring(0, 1))
						console.log("set bausteinValue in cart extras", product.map_id.substring(0, 1))
						shop.toast( translate( "Baustein hinzugefügt" ) )
						setDirty( false )
						await delay( 300 )
						setModalOpen(false)
						setLoading( false )
						history.push("/return/contactPerson")

                      
                    }}
                  >
                    Ja, Baustein hinzufügen
                  </Button>
				  							<Button style={{borderRadius: "25px", height: "45px"}} onClick={() => {
								setModalOpen(false)
							}}>Abbrechen</Button>
					</div>
					
					</Modal.Content>
				</Modal>
		{!additionalArticle && <Button
			primary
			loading={isLoading}
			style={{width: place == "returnEmpfehlung" ? "150px" : "150px", borderRadius: "25px"	}}
			onClick={async () => {
				let n = 1

				setLoading( true )
				if (!primaryProduct) {
					setLoading(false)
					setModalOpen(true)
					return
				}
				else{
				product.count = n
				await shop.cart.setExtra("lieferzeitraum", product.extras && product.extras.lieferzeitraum && product.extras.lieferzeitraum.value ? product.extras.lieferzeitraum.value.value : "")
				const productsToRemove = shop.cart.products.filter(p => !(p.extras && p.extras.additionalArticle === true))
				console.log("productsToRemove", productsToRemove)
				for (const p of productsToRemove) {
					await shop.cart.remove(p)
				}
				await shop.cart.add( product )
				shop.toast( translate( "Baustein hinzugefügt" ) )
				setDirty( false )
				await delay( 300 )
				setLoading( false )
				history.push("/return/quantityAddons")
				}
			}}>
				<div style={{display: "flex", flexDirection: "column", alignItems: "center", lineHeight: "1.2"}}>
					<span style={{fontWeight: "bold", fontSize: "15px"}}>{place == "returnEmpfehlung" ? translate("Empfehlung bestellen") : translate("Bestellen")}</span>
					<span style={{fontWeight: "normal", fontSize: "11px", opacity: 0.85}}>{translate("→ weiter zu Zusatzsortimenten")}</span>
				</div>
			</Button>}
			{additionalArticle && <Fragment>
								<div style={{display: "flex", flexDirection: "column", alignItems: "flex-start", gap: "6px"}}>
									<div style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
										{product &&
										<Input style={{borderRadius: "35px", height: "40px"}} className="transparent ba b--black-20 bw1 pr1 pl1" type="number" min={minBuy} max={9} placeholder={minBuy}
										  value={count}
										  action
										  onChange={e => {
											let value = e.target.value.replace(/[^0-9]/g, "")
											if (value !== "") value = Math.min(9, Math.max(1, Number(value)))
											setDirty(true)
											setCount(value)
										  }}
										  onBlur={e => {
											if (Number(e.target.value) < minBuy) {
											shop.toast(translate(`Mindestbestellmenge wurde korrigiert.`), "warning", false, "top");
											setCount(minBuy)
											}
											else if (Number(e.target.value) > 9) {
											setCount(9)
											}
										  }}>
										  <Button style={{borderRadius: "35px", backgroundColor: "#ffffff", width: "30px"}} icon="minus" onClick={() => {
											setDirty(true)
											setCount(prev => Math.max(Number(prev) - 1, minBuy))
										  }} />
										  <input style={{ width: "50px", height: "40px", textAlign: "center", border: "none"}} onFocus={(e) => e.target.style.outline = "none"} />
										  {/*<Select key={product.map_id} compact options={veOptions} defaultValue={product.quantities && product.quantities[ 0 ].map_desc_id}
											  onChange={( e, data ) => {
												const { value } = data
												const ve = product.quantities.filter( q => q.map_desc_id === value )
												if ( !ve ) return
												product.unit_multi = ve[ 0 ].multi
												product.unit_id = ve[ 0 ].map_desc_id
												console.log( { data, e, value: e.target.value, target: e.target } )
											  }
											  }
										  />*/}

										  <Button style={{borderRadius: "35px", backgroundColor: "#ffffff", width: "30px" }} className="mr2" icon="plus" onClick={() => {
											setDirty(true)
											setCount(prev => Math.min(Number(prev) + 1, 9))
										  }} />
									  </Input>}
									  <Button style={{borderRadius: "35px", backgroundColor: "#ffffff", color: "#265a88"}} icon="big cart" onClick={() => {
										product.count = Number(count) < minBuy ? minBuy : Number(count)
										shop.cart.add( product, { additionalArticle: true } )
										shop.toast( `${product.count} ${product.unit_desc} x ${product.title} ${translate("im Warenkorb")}`, "info", false, "bottom" )
									  }} />
									</div>
									{shop.cart.products.find( p => p.map_id === product.map_id ) &&
										<Button style={{ width: "100%", borderRadius: "35px", backgroundColor: "transparent", color: "red", border: "1px solid red"}} onClick={() => {
											const cartProduct = shop.cart.products.find( p => p.map_id === product.map_id )
											if ( cartProduct ) shop.cart.remove( cartProduct )
											shop.toast( translate("Artikel entfernt"), "info", false, "bottom" )
										}}>{translate("Entfernen")}</Button>
									}
								</div></Fragment>}
	</div>
}

function delay( ms ) {
	return new Promise( resolve => setTimeout( resolve, ms ) );
}


// WEBPACK FOOTER //
// ./src/theme/braunsheitmannShop/components/Product/ProductListItem.js